/**
 * Tailwind z-index classes for stacked overlays.
 * Keep in sync with: LoadingOverlay (z-[2000]), UserAuthenticationGuard (z-[2000]),
 * mobile sidebar scrim (z-[999]), license purchase stack (success < purchase < payment).
 */
export const MODAL_LAYER = {
  /** Default dialogs, legal, contract dashboard, generator confirms */
  standard: 'z-50',
  /** Post-purchase success (above page loading overlay) */
  success: 'z-[2001]',
  /** License purchase summary (below payment step) */
  purchase: 'z-[4000]',
  /** Payment form (top of purchase flow) */
  payment: 'z-[5000]'
};
